<template>
  <div
    :class="[
      'app-form-block',
      {
        'app-form-block-mguu': isMguuRespondent,
        'app-form-block_half': props.half,
        'app-form-block_hide-details': props.hideDetails
      }
    ]"
  >
    <div
      v-if="$slots.label"
      :class="[
        'app-form-block__label',
        {
          'app-form-block__label--active': props.active
        }
      ]"
      :style="props.labelStyle"
    >
      <slot name="label" />
    </div>

    <slot />

    <div
      v-if="errors.length > 0"
      class="app-form-block__error"
    >
      {{ errors[0].$message ?? errors[0] }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";

interface Props {
  errors?: any[]
  hideDetails?: boolean
  half?: boolean
  active?: boolean
  labelStyle?: Record<string, string> | string
}

const props = withDefaults(defineProps<Props>(), {
  errors: () => [],
  hideDetails: false,
  half: false,
  active: false,
  labelStyle: ''
})

const store = useStore();
const isMguuRespondent = computed(() => {
  return import.meta.env.VITE_APP_DESIGN_TYPE === 'mguu' && store.getters.authUserRoleSlug === 'respondent';
});
</script>

<style lang="scss" src="./AppFormBlock.scss" />